import React, { useState } from "react";
import Home  from "./Home";
import Header from "./Header";


export default function App() {
  return(
    <div>
      <Header/>
     <Home/>
    </div>
  );
}

